var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.998 4.92 C 14.715 3.964 15.313 2.648 15.074 1.333 C 13.878 1.453 12.563 2.17 11.726 3.127 C 11.009 4.083 10.411 5.279 10.65 6.594 C 11.965 6.713 13.28 5.876 13.998 4.92 Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.333 18.928 C 19.855 20.004 19.497 20.602 18.899 21.558 C 17.943 22.873 16.747 24.667 15.074 24.667 C 14.356 24.667 13.998 24.547 13.519 24.308 C 12.922 24.069 12.444 23.83 11.368 23.83 C 10.411 23.83 9.814 24.069 9.216 24.308 C 8.738 24.428 8.379 24.667 7.662 24.667 C 6.108 24.667 4.912 23.113 3.836 21.678 C 1.326 17.852 1.087 13.189 2.641 10.798 C 3.717 9.005 5.51 8.049 7.184 8.049 C 8.02 8.049 8.738 8.288 9.455 8.527 C 10.172 8.766 10.65 9.005 11.368 9.005 C 11.965 9.005 12.444 8.885 13.041 8.646 C 13.759 8.407 14.476 8.168 15.552 8.168 C 17.106 8.168 18.66 8.885 19.736 10.32 C 16.03 12.233 16.628 17.493 20.333 18.928 Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/mac.ef8ce656050bfa49ad17e0585eb0cfca.svg";
export { ForwardRef as ReactComponent };